import React from "react";
import AppRoutes from "./AppRoutes";
import { AuthSessionProvider } from "./contexts/AuthSessionProvider";
import { TrialProvider } from "./contexts/TrialProvider";
import { CSRContextProvider } from "./contexts/CSRContextProvider";

const App: React.FC = () => {
  return (
    <AuthSessionProvider>
      <TrialProvider>
        <CSRContextProvider>
          <AppRoutes />
        </CSRContextProvider>
      </TrialProvider>
    </AuthSessionProvider>
  );
};

export default App;



